<template lang="html">
	<div
	id="home"
	data-sal="slide-up"
	data-sal-duration="2000"
	data-sal-easing="ease-out-back"
	class="section1-container">
		<img class="bg-image" src="@/assets/img/bg1.png">
		<img class="site-screenshot" src="@/assets/img/screenshot.png">
		<a href="https://www.cameraoffsetproject.com/" target="_blank">
			<button>
				View the Project
			</button>
		</a>
	</div>
</template>

<script>
import sal from "sal.js"; // No need to use in main.js file

export default {
    mounted() {
        sal();
    },
}
</script>

<style scoped lang="scss">
.section1-container {
	width: 80%;
	max-width: 800px;
	height:100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	.bg-image {
		position:absolute;
		z-index: -10;
		height:100vh;
	}
	button {
		display: inline-block;
		padding: 15px 25px;
		margin: 30px;
		font-size: 24px;
		cursor: pointer;
		text-align: center;
		text-decoration: none;
		outline: none;
		color: #fff;
		font-family: ITCSouvenirBold;
		background-color: $main-2;
		border: none;
		border-radius: 15px;
		transition: .5s;
		&:hover {
			background-color: white;
			color: $main-2;
		}
	}
	h1 {
		padding-top:50px;
		font-size:40px;
		color: white;
		font-weight: 800;
    font-size: 3rem;
    font-family: ITCSouvenirBold;
    z-index: 1000;
    line-height: 116%;
	}
	.site-screenshot {
		width:100%;
		border-radius: 15px;
		margin-top: 15vh;
		@media only screen and (max-width: $screen-phone-max)  {
			margin-top: 25vh;
		}
	}
}

.single-image {
	padding-top: 20vh;
	width:80%;
	max-width:400px;
}
    
</style>